import { SimpleTask } from './simpleTask.types'

export const createSimpleTask = ({
  name,
  taskReferenceName,
  inputParameters
}: Pick<
  SimpleTask,
  'name' | 'taskReferenceName' | 'inputParameters'
>): SimpleTask => {
  return {
    type: 'SIMPLE',
    name,
    taskReferenceName,
    optional: false,
    inputParameters,
    asyncComplete: false,
    startDelay: 0
  }
}
